<template>
  <div :class="[ 'Toggle', { 'Toggle-checked': this.checked } ]" @click="handleChange">
    <span :class="[ 'thumb', { 'thumb-checked': this.checked } ]" />
  </div>
</template>

<script>

/*
 * This component is quite straightforward visually / behaviouraly
 * however more tricky on the acessibility / native mimicking side
 * of things.
 *
 * TODO: should use a hidden <input type="checked" />
 *
 * TODO: should emit an actual dom-event
 */

export default {
  name: 'Toggle',

  model: {
    prop: 'checked',
    event: 'change'
  },

  props: {
    checked: {
      type: Boolean
    }
  },

  methods: {
    handleChange () { 
      this.$emit('change', !this.checked)
    }
  }
}

</script>

<style scoped>

.Toggle {
  display: inline-block;
  width: 36px;
  padding: 4px;
  height: 20px;
  border-radius: 10px;
	cursor: pointer;
	@apply 
		bg-dull
}

.thumb {
  display: block;
  background: white;
  height: 12px;
  width: 12px;
  border-radius: 50%;
  transition: transform 150ms ease-out;
}

.Toggle-checked {
	@apply
		bg-primary
}

.thumb-checked {
  transform: translateX(16px);
}

</style>
